import { useSetPlayerStoreData } from '../hooks'
import { playerStoreKeys } from '../playerStoreConstants'

export const useSetPlayerLoyaltyData = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()

  const setPlayerLoyaltyData = loyaltyData => {
    setPlayerStoreData(
      {
        [playerStoreKeys.playerLoyaltyData]: loyaltyData
      },
      'setPlayerLoyaltyData'
    )
  }

  return { setPlayerLoyaltyData }
}
